/**
 * Fixed message category IDs (must match DB message_categories.id and API).
 * 1=info (normal), 2=warning, 3=success, 4=danger
 */
export const MESSAGE_CATEGORY_IDS = {
  INFO: 1,
  WARNING: 2,
  SUCCESS: 3,
  DANGER: 4
}

export const MESSAGE_CATEGORY_NAME_TO_ID = {
  info: MESSAGE_CATEGORY_IDS.INFO,
  normal: MESSAGE_CATEGORY_IDS.INFO,
  default: MESSAGE_CATEGORY_IDS.INFO,
  warning: MESSAGE_CATEGORY_IDS.WARNING,
  success: MESSAGE_CATEGORY_IDS.SUCCESS,
  ok: MESSAGE_CATEGORY_IDS.SUCCESS,
  danger: MESSAGE_CATEGORY_IDS.DANGER
}

/**
 * @param {number|string|undefined} categoryId
 * @param {string|undefined} categoryName
 * @param {string|number|undefined} typeMessage
 */
export function resolveMessageCategoryId ({ categoryId, categoryName, typeMessage } = {}) {
  if (categoryId != null && categoryId !== '') {
    const n = parseInt(categoryId, 10)
    if (n >= MESSAGE_CATEGORY_IDS.INFO && n <= MESSAGE_CATEGORY_IDS.DANGER) {
      return n
    }
  }
  if (String(typeMessage) === '4') {
    return MESSAGE_CATEGORY_IDS.WARNING
  }
  const name = String(categoryName || '').trim().toLowerCase()
  if (name && MESSAGE_CATEGORY_NAME_TO_ID[name] != null) {
    return MESSAGE_CATEGORY_NAME_TO_ID[name]
  }
  return MESSAGE_CATEGORY_IDS.INFO
}

function readLegacyMessageColorNumeric (message) {
  const colorRaw = message?.message_color ?? message?.messageColor ?? message?.color
  if (colorRaw == null || colorRaw === '' || colorRaw === 'warning' || colorRaw === 'error') {
    return 0
  }
  if (typeof colorRaw === 'number') return colorRaw
  const parsed = parseInt(String(colorRaw), 10)
  return Number.isFinite(parsed) ? parsed : 0
}

/**
 * Resolve the notification sound category for a normalized or socket message,
 * including legacy message_color / danger_message fields.
 * @param {object} message
 */
export function resolveMessageNotificationCategoryId (message) {
  if (!message) return MESSAGE_CATEGORY_IDS.INFO

  if (
    message.danger_message === 1 ||
    message.danger_message === true ||
    message.danger_message === '1'
  ) {
    return MESSAGE_CATEGORY_IDS.DANGER
  }

  let categoryId = resolveMessageCategoryId({
    categoryId: message.categoryId ?? message.category?.id,
    categoryName: message.categoryName ?? message.category?.name,
    typeMessage: message.typeMessage
  })

  if (categoryId === MESSAGE_CATEGORY_IDS.INFO) {
    const legacyColorNumeric = readLegacyMessageColorNumeric(message)
    if (legacyColorNumeric === 1) categoryId = MESSAGE_CATEGORY_IDS.DANGER
    else if (legacyColorNumeric === 2) categoryId = MESSAGE_CATEGORY_IDS.SUCCESS
  }

  return categoryId
}

/**
 * @param {Record<string, object>} messageCategoriesById
 * @param {number|string|undefined} categoryId
 * @param {string|undefined} categoryName
 */
export function findMessageCategoryInStore (messageCategoriesById, categoryId, categoryName) {
  if (!messageCategoriesById || typeof messageCategoriesById !== 'object') return null

  const byKey =
    messageCategoriesById[categoryId] ??
    messageCategoriesById[String(categoryId)]
  if (byKey) return byKey

  const idNum = Number(categoryId)
  if (Number.isFinite(idNum)) {
    const byId = Object.values(messageCategoriesById).find(
      category => Number(category?.id) === idNum
    )
    if (byId) return byId
  }

  const name = String(categoryName || '').trim().toLowerCase()
  if (!name) return null
  return Object.values(messageCategoriesById).find(
    category => String(category?.name || '').trim().toLowerCase() === name
  ) ?? null
}
